import React from 'react';

const CircleCheck = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    {...props}
  >
    <path d="M16 27C22.0751 27 27 22.0751 27 16C27 14.5462 26.718 13.1584 26.2057 11.8881L27.7219 10.3719C28.541 12.0749 29 13.9838 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 8.8203 8.8203 3 16 3C18.9805 3 21.7267 4.003 23.9195 5.68988L22.491 7.11837C20.6716 5.78641 18.4276 5 16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27ZM28.2072 7.20698L16.7063 18.7119C16.5187 18.8995 16.2642 19.0049 15.9988 19.0049C15.7335 19.0048 15.479 18.8992 15.2915 18.7115L11.2924 14.7066C10.9021 14.3158 10.9026 13.6826 11.2934 13.2924C11.6842 12.9021 12.3174 12.9026 12.7076 13.2934L15.9995 16.59L26.7928 5.79302C27.1832 5.40242 27.8164 5.40231 28.207 5.79277C28.5976 6.18323 28.5977 6.81639 28.2072 7.20698Z" />
  </svg>
);

export default CircleCheck;
